import React from 'react';
import { Outlet } from 'react-router-dom';

const Generic = () => {
    return <Outlet />
}

export default Generic;